// Not paired and no link: say how to pair, plainly. The QR code is made at the desk.
import { PRODUCT_NAME } from "../brand";
import { Brand, Page } from "../components/Shell";

export function Welcome() {
  return (
    <>
      <header className="topbar">
        <Brand />
      </header>
      <Page tabs={false} className="pair">
        <h2>Pair this phone from your desk.</h2>
        <p>
          On your PC, run <code>whistle pair</code> in a terminal. Scan the QR code it prints with your phone's camera, and this page opens with everything it needs.
        </p>
        <ol className="help" style={{ paddingLeft: "1.3em", listStyle: "decimal", display: "flex", flexDirection: "column", gap: 8 }}>
          <li>Run <code>whistle pair</code> at the desk.</li>
          <li>Scan the code with the camera.</li>
          <li>Type the six-character code the phone shows into the terminal.</li>
        </ol>
        <p className="small muted">
          {PRODUCT_NAME} keeps its keys in this browser. Use the browser you want alerts in (on Android, usually Chrome), not a private tab.
        </p>
      </Page>
    </>
  );
}
